export type RefreshModalDetail = {
  // i18n keys (preferred)
  titleKey?: string;
  descriptionKey?: string;
  buttonLabelKey?: string;
  ignoreLabelKey?: string;
  // i18n vars (optional)
  titleVars?: Record<string, unknown>;
  descriptionVars?: Record<string, unknown>;
  buttonLabelVars?: Record<string, unknown>;
  ignoreLabelVars?: Record<string, unknown>;
  allowIgnore?: boolean;
};

export function showRefreshModal(detail: RefreshModalDetail = {}) {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent('show_refresh_modal', { detail }));
  } catch {
    // ignore
  }
}

export function showSaveFailedRefreshModal() {
  showRefreshModal({
    titleKey: 'refreshModal.saveFailed.title',
    descriptionKey: 'refreshModal.saveFailed.description',
    buttonLabelKey: 'refreshModal.refreshPage',
    allowIgnore: true,
    ignoreLabelKey: 'refreshModal.ignore',
  });
}

export function showSaveTimeoutRefreshModal() {
  showRefreshModal({
    titleKey: 'refreshModal.saveTimeout.title',
    descriptionKey: 'refreshModal.saveTimeout.description',
    buttonLabelKey: 'refreshModal.refreshPage',
    allowIgnore: true,
    ignoreLabelKey: 'refreshModal.ignore',
  });
}